interface IPerformanceEntry extends PerformanceEntry {
  readonly type?: string;
}

export const pageAccessedByReload = () =>
  (window.performance.navigation && window.performance.navigation.type === 1) ||
  (window.performance.getEntriesByType?.("navigation") || [])
    .map((nav: IPerformanceEntry) => nav.type)
    .includes("reload");
